export default __webpack_public_path__ + "static/media/decorpot_new_logo.97daf5f6.png";